import React, {Component, Fragment} from 'react'
import { withStyles } from '@material-ui/core/styles'
import Wrapper from '../wrapper'
import License from './License'
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../app-button/button'
import Checkbox from '@material-ui/core/Checkbox'
import PaymentTariffs from './PaymentTariffs'
import PaymentHistory from "./PaymentHistory";
import {declOfNum} from "../../utils/Utils";
import cx from "classnames";

const styles = theme => ({
  paymentBox: {
    maxWidth: 380,
    marginLeft: 48,
    padding: '16px 32px',
    borderRadius: 8,
    position: 'relative',
  },
  lastPaymentBtns: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
  },
  paymentTitle: {
    marginBottom: 24,
    fontFamily: 'Roboto',
    fontSize: 8,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 2,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
  paymentSubTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'red',
  },
  paymentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  paymentContent: {
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  paymentInfoList: {
    listStyleType: 'none',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.65)',
    '& li': {
      marginBottom: 16,
    },
    '& a': {
      pointerEvents: 'none',
      cursor: 'default',
      color: '#006fff',
      textDecoration: 'underline',
    },
  },
  paymentNext: {
    display: 'block',
    whiteSpace: 'pre-line',
  },
  paymentStatistics: {
    display: 'block',
  },
  paymentOffer: {
    display: 'flex',
    marginBottom: 24,
    marginLeft: '-15px',
  },
  paymentOfferLink: {
    color: '#000000',
    textDecoration: 'underline',
  },
  addBtnCard: {
    width: '100%',
    height: 40,
    padding: 0,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
  },
  disabled: {
    color: 'red',
  },
  linkInLine:{
    lineBreak: 'anywhere'
  }
})

class AddPaymentCardLegalUser extends Component {
  state = {
    isAgree: false,
    license: window.state.license,
    nextPayment: window.state.nextPayment,
    isLegal: window.state.isLegal,
    statistics: window.state.statistics,

  }

  handleChange = event => {
    this.setState({
      isAgree: event.target.checked,
    })
  }


  render() {
    const {classes} = this.props
    const {
      license,
      isLegal,
      statistics: { sessionsFor30Days },
      nextPayment: {date, amount},
    } = this.state

    const paymentPeriod = license.type != 'TRIAL' ? (
      <p>
        <b>Оплаченный период:</b><br/>
        {license.expirationDate}
      </p>
    ) : null

      return (
  <Fragment>
        <h2 className={classes.paymentSubTitle}>Оплата по счету</h2>
          <p>Без своевременной оплаты доступ к сервису будет отключен</p>
          {paymentPeriod}
          <p>
            Оплачивая счет вы присоединяетесь к договору об использовании сервиса “ROMI center”, размещенному по адресу: <a href="https://romi.center/docs/ru_offer_ul.pdf" target="_blank" className={classes.linkInLine}>https://romi.center/docs/ru_offer_ul.pdf</a>
          </p>

    <div className={classes.paymentRow}>
      <div className={classes.lastPaymentBtns}>
        <PaymentTariffs />
      </div>
    </div>
          <ul className={classes.paymentInfoList}>
            <li>
              <span
                className={classes.paymentNext}
              >{`Следующий платеж:\n ${date}`}</span>
              {/*<span>{`Сумма следующего платежа - ${amount} руб.`}</span>*/}
            </li>
          </ul>

  </Fragment>
    )


  }
}

export default withStyles(styles)(AddPaymentCardLegalUser)
